import { Controller } from "@hotwired/stimulus"

// Passo 1 «Link» di Verifica bandi: una pagina già nota nel catalogo si propone solo se nessuna riga ha il suo
// indirizzo (s.pagine_proposte.filter((p) => !link.pagine.some((q) => q.url === p.url)) dell'originale), anche mentre
// si scrive, si aggiunge o si toglie una riga.
//   <div data-controller="righe pagine-link" data-action="input->pagine-link#aggiorna righe:aggiunta->pagine-link#aggiorna …">
//     <input data-pagine-link-target="url"> … <div data-pagine-link-target="proposta" data-url="https://…">
export default class extends Controller {
  static targets = ["url", "proposta"]

  connect() { this.aggiorna() }

  aggiorna() {
    const usate = new Set(this.urlTargets.map((el) => el.value))
    this.propostaTargets.forEach((p) => { p.hidden = usate.has(p.dataset.url) })
  }
}
